import { Link, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { FileText } from "lucide-react";

export default function FloatingQuote() {
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin")) return null;

  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 1.2, duration: 0.5 }}
      className="fixed bottom-5 right-5 z-40 sm:bottom-6 sm:right-6"
    >
      <Link
        to="/contact"
        data-testid="floating-request-quote-btn"
        className="group inline-flex items-center gap-2.5 rounded-full bg-blue-600 py-3.5 pl-5 pr-6 text-sm font-semibold text-white shadow-[0_10px_28px_-6px_rgba(37,99,235,0.55)] transition-all hover:scale-[1.04] hover:bg-blue-700 active:scale-95"
      >
        <span className="pulse-dot inline-block h-2 w-2 rounded-full bg-emerald-400" aria-hidden="true" />
        Request a Quote
        <FileText className="h-4 w-4 opacity-80 transition-transform group-hover:translate-x-0.5" aria-hidden="true" />
      </Link>
    </motion.div>
  );
}
